// extracted by mini-css-extract-plugin
module.exports = {"container":"Carrello_container__6oaCs","fullCart":"Carrello_fullCart__aNOdC","visibile":"Carrello_visibile__a13zm","sheet":"Carrello_sheet__uBDHn"};